import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumbersOnly]',
  standalone: true,
})
export class NumbersOnlyDirective {
  private readonly ngControl = inject(NgControl);

  @HostListener('input', ['$event'])
  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement | null;

    if (!input) return;

    const sanitizedValue = input.value.replace(/[^0-9]/g, '');

    this.ngControl.control?.setValue(sanitizedValue);

    if (input.value !== sanitizedValue) {
      input.value = sanitizedValue;
    }
  }
}
